// extracted by mini-css-extract-plugin
export default {"wrapper":"LangSelect_wrapper__OhGWo","and":"LangSelect_and__89vis"};